<template>
  <el-dialog
    width="30%"
    :title="config.title"
    :visible.sync="dialogFormVisible"
  >
    <div>
      <el-alert
        :title="title"
        type="warning"
        show-icon
        :closable="false"
      />
      <div class="url">
        {{ config.url }}
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">
        取 消
      </el-button>
      <el-button type="primary" @click="copyUrl">
        复制链接
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'InviteAuthDialog',
  data() {
    return {
      dialogFormVisible: false,
      config: {
        url: 'https://customer.yunlizhi.cn/#/order/createOrder',
      },
      title: '',
    };
  },
  methods: {
    show(config) {
      this.config = config;
      this.title = `复制下方链接，发送至“${config.row.enterpriseName}”的法人或经办人，邀请其完成认证（认证成功后可生成具有法律效应的电子回单）`;
      this.dialogFormVisible = true;
    },
    async copyUrl() {
      await this.$copyText(this.config.url);
      this.$message({
        type: 'success',
        message: '复制成功！',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.url{
  margin-top: 24px;
  color: #06B880;
}
</style>
